import { getMyVoiceRoomAdmin } from '@/api/voice-room';
export class VoiceRoom {
  roomInfo = {};
  adminList = []; //管理员
  memberList = []; //成员
  setRoomInfo(roomInfo) {
    this.roomInfo = roomInfo;
  }
  // 获取房间管理员
  async getAdminList(roomUid) {
    const { data } = await getMyVoiceRoomAdmin({
      roomUid: roomUid || this.roomInfo.roomUid
    });
    this.adminList = data || [];
    return data; //data为null时表示当前用户非管理员，无权限获取
  }
  setMemberList(memberList) {
    this.memberList = memberList;
  }
}
const VoiceRoomProvider = new VoiceRoom();
console.log('VoiceRoomProvider', VoiceRoomProvider);
export default VoiceRoomProvider;
